import React, { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';

import { FaTrash } from 'react-icons/fa';
import { Box } from '@chakra-ui/react';
import DrawerButton from '../buttons/drawerButton';
import { accountTypeOptions } from 'components/allForm/PurchaseItem/selectedOptions';
import InputFormControl from '../inputFormControl';

const BankForm = ({ bankDetail,companyName, index, removeBankDetail, handleChange,handleBlur,errors }) => {
    const [isOpen, setIsOpen] = useState(true);

  return (
    <div className={`payment-listing_box mb-4 ${isOpen ? "show" : "hide"}`}>
      <div className="payment-list_array mt-3">
        <div className="d-flex">
          <span className="payment-details ">Bank Details {index + 1}</span>
        </div>

        <div className="d-flex toggleImage-content">
          <span className="mt-0 mx-2">
            <FaTrash
              style={{
                fontSize: "16px",
                color: "red",
                cursor: "pointer",
              }}
              onClick={() => removeBankDetail(index)}
            />
          </span>
          <DrawerButton
            isOpen={isOpen}
            handleClick={() => {
              setIsOpen(!isOpen);
            }}
          />
        </div>
      </div>
      {isOpen && (
        <>
          <Row>
            <Col>
              <Box display="flex" className="input-box">
                <Form.Label>Account Holder Name</Form.Label>
                <InputFormControl
                  name={`bankDetails.${index}.hol`}
                  placeholder="Enter Account Holder Name"
                  value={bankDetail.hol ? bankDetail.hol : companyName}
                  handleChange={(e) => handleChange(e)}
                />
              </Box>
            </Col>
            <Col></Col>
          </Row>
          <Row>
            <Col>
              <Box display="flex" className="input-box">
                <Form.Label>
                  Account Number <span className="span-star">*</span>
                </Form.Label>
                <InputFormControl
                  name={`bankDetails.${index}.acNo`}
                  placeholder="Enter Account Number"
                  value={bankDetail.acNo}
                  handleChange={(e) => handleChange(e)}
                  isInvalid={!!errors[`bankDetails.${index}.acNo`]}
                />
              </Box>
              <p className="form_error">
                {" "}
                {errors[`bankDetails.${index}.acNo`]}
              </p>
            </Col>
            <Col>
              <Box display="flex" className="input-box">
                <Form.Label>
                  IFSC Code <span className="span-star">*</span>
                </Form.Label>
                <InputFormControl
                  name={`bankDetails.${index}.ifc`}
                  placeholder="Enter IFSC Code"
                  value={bankDetail.ifc}
                  handleChange={(e) => handleChange(e)}
                  handleBlur={() => handleBlur(index)}
                  isInvalid={!!errors[`bankDetails.${index}.ifc`]}
                />
              </Box>
              <p className="form_error">
                {" "}
                {errors[`bankDetails.${index}.ifc`]}
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <Box display="flex" className="input-box">
                <Form.Label>Account Type</Form.Label>
                <Form.Select
                  name={`bankDetails.${index}.typ`}
                  value={bankDetail.typ}
                  onChange={(e) => handleChange(e)}
                  className="custom--dropdown-container"
                >
                  {accountTypeOptions.map((option) => (
                    <option key={option.value} value={option.id}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Box>
            </Col>
            <Col>
              <Box display="flex" className="input-box">
                <Form.Label>Bank Name</Form.Label>
                <InputFormControl
                  name={`bankDetails.${index}.bnk`}
                  placeholder="Enter Bank Name"
                  value={bankDetail.bnk}
                  handleChange={(e) => handleChange(e)}
                />
              </Box>
            </Col>
          </Row>
          <Row>
            <Col>
              <Box display="flex" className="input-box">
                <Form.Label>SWIFT Code</Form.Label>
                <InputFormControl
                   name={`bankDetails.${index}.swt`}
                   placeholder="Enter SWIFT Code"
                   value={bankDetail.swt}
                   handleChange={(e) => handleChange(e)}
                />
              </Box>
            </Col>
            <Col>
              <Box display="flex" className="input-box">
                <Form.Label>Branch Name</Form.Label>
                <InputFormControl
                   name={`bankDetails.${index}.bch`}
                   placeholder="Branch Name"
                   value={bankDetail.bch}
                   handleChange={(e) => handleChange(e)}
                />
              </Box>
            </Col>
          </Row>

          <Row>
            <Col>
              <Box display="flex" className="input-box">
                <Form.Label>City</Form.Label>
                <InputFormControl
                   name={`bankDetails.${index}.bAd.ct`}
                   placeholder="City"
                   value={bankDetail.bAd.ct}
                   handleChange={(e) => handleChange(e)}
                />
              </Box>
            </Col>
            <Col>
              <Box display="flex" className="input-box">
                <Form.Label>State</Form.Label>
                <InputFormControl
                   name={`bankDetails.${index}.bAd.st`}
                   placeholder="State"
                   value={bankDetail?.bAd?.st}
                   handleChange={(e) => handleChange(e)}
                />
              </Box>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default BankForm;